<template>
    
    <div class="wrap">
        <rotate-detect></rotate-detect><!--  template   -->
        
        <div class="topbar"></div>
        <div class="rightbar"></div>
        <div class="content">
            <nav-bar :nav="showNav"></nav-bar><!--  template   -->
            <section class="artistpage">
          <div class="block"><svg class="svg100" ratio="0.25" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 480"><title>blockwhite</title><polygon points="1920 0 0 480 0 0 1920 0" /></svg></div>
          <div class="main">
            <div class="bookmark"><img src="../asset/svg/bookmark/v/artist.svg" alt="多寶創作人"></div>
            <div class="max1000"><a href="/#/?from_artist" class="arrow_back" onclick="gaclick('btn_artist_back')">
                <svg class="arrowtop" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.86 18.28"><title>top</title><path d="M33.38,15.63,16,.39a1.57,1.57,0,0,0-2.58,1.15Q7.08,8.78.42,15.73c-1.33,1.38.77,3.49,2.1,2.1Q9.12,11,15.37,3.8l15.9,13.94C32.71,19,34.82,16.9,33.38,15.63Z" /></svg>
                <svg class="arrowbg"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.86 93.28"><title>btn</title><path d="M0,48.67C-.06,29,12.8,9.5,31,1.79c12.47-5.27,33.3,1.68,39.81,13.45C73.66,20.35,78,24,82.3,27.59c3,2.52,4.79,5.39,4.3,9.48-.39,3.29,1,6.16,2.46,9a15.11,15.11,0,0,1,.18,14c-12.18,25.24-30,34.78-54.36,33a16,16,0,0,1-8.06-2.36C11.93,80.51,0,68.37,0,48.67Z" /></svg></a>
              <h2 class="artistdescription wow1 fadeInUp"><img src="../img/artist/artistpage5.svg" alt="小小色彩大大天空"></h2>
              <div class="artistinfo">
                <div class="artistpic wow1 fadeInUp"><img src="../img/artist/artist05.jpg"></div>
                <div class="txtcontent strip">
                  <h2 class="wow2 fadeInUp"><span>創作人/</span><b>許祐綸</b></h2>
                  <p class="wow3 fadeInUp">只有2、3歲孩子的語言能力，1~12數字仍然無法熟悉分辨，20歲的祐綸，歲月會是什麼呢？每個年、月、日、時、分，都不在他的世界裡。<br><br>祐綸愛畫畫，畫什麼呢？我只是在「畫畫」。除了單純的「畫畫」祐綸無法以文字語言告訴別人他在想什麼。<br><br>就這樣畫畫，開心的笑容和簡單的筆觸，難以形容的隨性色彩，綻放出最原始的畫畫的魅力。</p>
                </div>
              </div>
              <div class="worklist">
                <ul>
                  <li>
                    <div class="featurepic wow1 fadeInUp"><img src="../img/artist/work05_1.jpg" alt=""></div>
                    <h3 class="wow2 fadeInUp">我在畫圖</h3>
                    <p class="wow3 fadeInUp">54.5(L) x 39.3(M)cm (4K) 色鉛筆 2012.</p>
                  </li>
                  <li>
                    <div class="featurepic wow1 fadeInUp"><img src="../img/artist/work05_2.jpg" alt=""></div>
                    <h3 class="wow2 fadeInUp">自由創作</h3>
                    <p class="wow3 fadeInUp">54.5(L) x 39.3(M)cm (4K) 水彩 2009.</p>
                  </li>
                  <li>
                    <div class="featurepic wow1 fadeInUp"><img src="../img/artist/work05_3.jpg" alt=""></div>
                    <h3 class="wow2 fadeInUp">自由創作</h3>
                    <p class="wow3 fadeInUp">54.5(L) x 39.3(M)cm (4K) 水彩 2009.</p>
                  </li>
                </ul>
              </div><a href="javascript:void(0)" class="btn wow4 fadeInUp" onclick="trackWaitJump('btn_moreworks_xuyolun','https://taiwancurio.wordpress.com/category/%E8%A8%B1%E7%A5%90%E7%B6%B8/')">
                <!--blogicon-->
                <div class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.24 35.64"><title>read</title><path d="M36.64,0H23.83a4.64,4.64,0,0,0-3.2,1.33A4.64,4.64,0,0,0,17.42,0H4.6A4.67,4.67,0,0,0,0,4.6V27.83a4.67,4.67,0,0,0,4.6,4.6H17.42a1.78,1.78,0,0,1,1.8,1.8,1.4,1.4,0,0,0,1.4,1.4,1,1,0,0,0,.41-.07,1.28,1.28,0,0,0,.82-.63,1.25,1.25,0,0,0,.17-.7,1.78,1.78,0,0,1,1.8-1.8H36.64a4.67,4.67,0,0,0,4.6-4.6V4.6A4.67,4.67,0,0,0,36.64,0ZM22,4.6a1.78,1.78,0,0,1,1.8-1.8H36.64a1.78,1.78,0,0,1,1.8,1.8V27.83a1.78,1.78,0,0,1-1.8,1.8H23.83A4.18,4.18,0,0,0,22,30Zm-2.8,0V30a4.18,4.18,0,0,0-1.8-.41H4.6a1.78,1.78,0,0,1-1.8-1.8V4.6A1.78,1.78,0,0,1,4.6,2.8H17.42A1.78,1.78,0,0,1,19.22,4.6Z" /></svg></div><span>更多祐綸的事</span></a>
            </div>
          </div>
          <div class="switchbtn"><router-link to="/artist4" class="btn artist4">
              <p> <span>創作人/</span><b>莊博為</b></p></router-link><router-link to="/artist6" class="btn artist6">
              <p><span>創作人/</span><b>陳瑩芷</b></p></router-link></div>
        </section>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import ScrollReveal from 'scrollreveal'
    
    import navBar from './common/Nav.vue'
    import rotateDetect from './common/RotateDetect.vue'

    export default {
      components: {
          navBar,
          rotateDetect
      },
      data: function() {
            return {
               showNav:false
            }
      },
      created: function() {
            //Scrolls to top when view is displayed
            window.scrollTo(0, 0);
      },
      mounted: function(){
          window.sr = ScrollReveal({ reset: true });
            // Customizing a reveal set
          var vv = function(ele,dur,del){
              sr.reveal(ele, { 
                  origin: 'bottom',
                  duration: dur,
                  delay: del,
                  opacity: 0,
                  scale: 1,
                  easing: 'cubic-bezier(0.42, 0, 0.58, 1)',
                  // mobile: true
              });
          }
          vv('.wow1',500,0);
          vv('.wow2',500,200);
          vv('.wow3',500,400);
          vv('.wow4',500,600);
          $('.main').animate({opacity:1});
          $('.logo').on('click',function(){
              window.location="/#/?from_artist";
              gaclick('btn_logo');
          });
          gapage('pv_xuyolun');
          
      }
    }
</script>

<style>
    @import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css';
</style>


// WEBPACK FOOTER //
// Artist5.vue?667534d7